module.exports = __webpack_public_path__ + "static/img/fazhanshiImg.9b2514b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/fazhanshiImg.png
// module id = 3NG/
// module chunks = 0